module.exports = __webpack_public_path__ + "media/images/emblems/Rohrbach-coat_of_arms-be522435f7e5b58260a3adf6c4340442.svg";